import { faApple } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Col, Collapse, Row, Spin imports
import { API, Auth } from 'aws-amplify'
import QueryString from 'query-string'
// Added Accordion, CBSpin imports
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocalization } from '../../../localization'
import { useGlobalState } from '../../../store'
import {
  colorApple,
  colorExchange,
  colorOutlook
} from '../../../utils/colors'
import { faOutlook } from '../../../utils/customIcons'
import { loadAccounts } from '../../../utils/fetchData'
import { Accordion } from '../../core/components/Accordion'
import { CBSpin } from '../../core/components/CBSpin'

import { getUser } from '../../../utils/auth'

import googlePermissions1 from '../../../images/Google-permissions-1.png'
import googlePermissions2 from '../../../images/Google-permissions-2.png'
import googlePermissions3 from '../../../images/Google-permissions-3.png'
import msftPermissions from '../../../images/Microsoft_OAuth_permissions.png'
import blurryGoog from '../../../images/permissions_goog.png'

import SEO from '../../../components/SEO'
import { ReactComponent as Arrow } from '../../../images/svg/arrow-right-chevron_dark.svg'
import { ReactComponent as Check } from '../../../images/svg/check_dark.svg'
import { ReactComponent as Connections } from '../../../images/svg/connections.svg'
import { ReactComponent as GoogleLogo } from '../../../images/svg/google-logo.svg'
import { ReactComponent as NewBooking } from '../../../images/svg/new-booking.svg'
import { ReactComponent as NewSync } from '../../../images/svg/new-sync.svg'
import { ReactComponent as Close } from '../../../images/svg/x-close.svg'
import {
  CBButton,
  CBHeader,
  CBInput,
  CBListItem,
  CBModal
} from '../../core/components/cbd'


const redirectToService = async (redirectUri) => {
  const credentials = await Auth.currentCredentials()
  // console.log(redirectUri)
  // alert(redirectUri)
  window.location.href = redirectUri
}

const AccountCreatePage = () => {
  const { t } = useLocalization()
  const navigate = useNavigate();
  const [showList, setShowList] = useState(false)
  const [callbackStatus, setCallbackStatus] = useState('loading')
  const [errorMessage, setErrorMessage] = useState('')
  const [, setAccounts] = useGlobalState('accounts')
  const [, setLoadingCoreData] = useGlobalState('loadingCoreData')
  const [license, setLicense] = useGlobalState('license')
  const [showApple, setShowApple] = useState(false)
  const [appleEmail, setAppleEmail] = useState('')
  const [appKey, setAppKey] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let params = QueryString.parse(window.location.search)
    if (params.test) {
      setCallbackStatus('error')
      setErrorMessage('THIS IS AN ERROR MESSAGE')
    } else if (params.code) {
      const type = window.location.pathname.includes('google') ? 'google' : 'ms'

      if (
        type == 'google' &&
        (!params.scope.includes('calendar.events') ||
          !params.scope.includes('calendar.readonly'))
      ) {
        setCallbackStatus('denied_scopes')
      } else {
        const type = window.location.pathname.includes('google')
          ? 'google'
          : 'ms'
        codeCallbackAccountCreation(params.code, type, params.state,"normal")
      }
    } else if (params.error == 'access_denied') {
      setCallbackStatus('denied')
    } else if (params.error == 'consent_required') {
      setCallbackStatus('denied')
    } else {
      setShowList(true)
    }
    if(params.caldav) {
      setAppleEmail(params.caldav)
      setShowApple(true)
    }
  }, [])

  const addApple = async (email, code) => {
    setLoading(true)
    const credentials = await Auth.currentCredentials()

    const username = getUser().username
    API.post('account', '/account/', {
      body: {
        code,
        type: 'caldav',
        state: email,
        redirect: 'none',
      },
    })
      .then(async (response) => {
        setCallbackStatus('success')
        redirectToService('/dashboard/accounts')

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'dashboardEvent',
          category: 'userActivity',
          action: 'createAccount',
          label: credentials.identityId,
          email: username,
        })
      })
      .catch((error) => {
        setLoading(false)
        // console.log(error)
        setCallbackStatus('error')
        setErrorMessage(error.response.data.message)
      })
  }
  const codeCallbackAccountCreation = async (code, type, state = 'normal',scope="normal") => {
    const credentials = await Auth.currentCredentials()

    const username = getUser().username

    API.post('account', '/account/', {
      body: {
        code,
        type,
        state,
        scope,
        redirect:
          type === 'ms'
            ? window.location.origin + process.env.REACT_APP_OAUTH_O365_URL
            : window.location.origin + process.env.REACT_APP_OAUTH_GOOGLE_URL,
      },
    })
      .then(async (response) => {
        setCallbackStatus('success')
        setLoadingCoreData(true)
        async function fetchData() {
          const accounts = await loadAccounts()
          setAccounts(accounts)
          setLoadingCoreData(false)
        }
        fetchData()

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'dashboardEvent',
          category: 'userActivity',
          action: 'createAccount',
          label: credentials.identityId,
          email: username,
        })
      })
      .catch((error) => {
        // console.log(error)
        setCallbackStatus('error')
        setErrorMessage(error.response.data.message)
      })
  }
  function hasThreeHyphens(str) {
    return (str.match(/-/g) || []).length === 3;
}
  function renderSelector() {
    return (
      <div className="cb-content-frame h-screen">
        <SEO title={t('accounts.connect_account')} /> {/* Localized */}
        <div className="cb-content-pane mobile_padding">
          <CBHeader
            label={t('accounts.add_account')} 
            icon={<Connections></Connections>}
          ></CBHeader>
          <div className="font-sarabun text-lg mb-6">
            {t('accounts.connect_work_personal')} {/* Localized */}
          </div>
          <CBModal
            disabled={loading}
            title={t('accounts.apple_icloud')} 
            visible={showApple}
            onCancelClick={(e) => setShowApple(false)}
            positiveLabel={loading ? t('common.submitting') : t('accounts.add_icloud_account_button')} 
            onPositiveClick={async (e) => {
              setErrorMessage(null)
              if(hasThreeHyphens(appKey)) {
                await addApple(appleEmail, appKey)
              } else {
                setErrorMessage("Not a valid application password, make sure you are not using your regular iCloud password. Application password is of the format: xxxx-xxxx-xxxx-xxxx")
              }
              
            }}
          >
            <div>
              <CBInput
                disabled={loading}
                value={appleEmail}
                onChange={(e) => {
                  setAppleEmail(e.toLowerCase())
                }}
                label={t('accounts.icloud_email_label')} 
              ></CBInput>
              <CBInput
                error={errorMessage ? t(errorMessage) : null} // Localize error message if it's a key
                type={'password'}
                label={t('accounts.app_specific_password_label')} 
                hint="xxxx-xxxx-xxxx-xxxx"
                value={appKey}
                onChange={(e) => {
                  setAppKey(e)
                }}
              ></CBInput>
              <a href="https://help.calendarbridge.com/user-docs/connecting-calendar-accounts/#icloud" target="_blank">
                {t('accounts.app_specific_password_help')} {/* Localized */}
              </a>
            </div>
          </CBModal>
          <div style={{ margin: '0 auto', paddingBottom: 16 }}>
            <div className="grid mb-4 lg:grid-cols-2 md:grid-cols-1 gap-2">
              <div
                className="main-grid-item "
                onClick={(e) =>
                  redirectToService(
                    `https://accounts.google.com/o/oauth2/v2/auth?client_id=${
                      process.env.REACT_APP_OAUTH_GOOGLE_CLIENT
                    }&redirect_uri=${
                      window.location.origin +
                      process.env.REACT_APP_OAUTH_GOOGLE_URL
                    }&response_type=code&prompt=login&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.events+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.readonly&access_type=offline`
                  )
                }
              >
                <div>
                  <div>
                    <GoogleLogo
                      className="ml-5 mb-4"
                      width="80"
                      height="80"
                    ></GoogleLogo>
                    {/* <FontAwesomeIcon
                      icon={faGoogle}
                      size="6x"
                      color={colorGoogle}
                      style={{ marginLeft: 10, marginRight: 10 }}
                    /> */}
                  </div>{' '}
                  <div class="t3">{t('accounts.google_account')}</div> {/* Localized */}
                </div>
              </div>
              <div
                className="main-grid-item"
                onClick={(e) =>
                  redirectToService(
                    `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?prompt=login&client_id=${
                      process.env.REACT_APP_OAUTH_O365_CLIENT
                    }&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=normal&redirect_uri=${
                      process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL
                    }`
                  )
                }
              >
                <div className="flex flex-col justify-center">
                  <div>
                    <FontAwesomeIcon
                      icon={faOutlook}
                      size="6x"
                      color={colorOutlook}
                      style={{
                        marginLeft: 40,
                        marginBottom: 10,
                      }}
                    />
                  </div>
                  <div class="t3">{t('accounts.microsoft_365_account')}</div> {/* Localized */}
                </div>
              </div>
            </div>
            
            <div
              className="flex flex-row border p-4 gap-x-4 items-center text-xl cursor-pointer mt-4 mb-4"
              onClick={(e) => setShowApple(true)}
            >
              <div>
                <FontAwesomeIcon
                  icon={faApple}
                  size="3x"
                  color={colorApple}
                  style={{
                    marginLeft: 18,
                    marginRight: 26,
                    marginBottom: 10,
                  }}
                />
              </div>
              {t('accounts.apple_icloud')} {/* Localized */}
            </div>
            <div
              className="flex flex-row border p-4 gap-x-4 items-center text-xl cursor-pointer mb-4"
              onClick={(e) =>
                redirectToService(
                  `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?prompt=login&client_id=${
                    process.env.REACT_APP_OAUTH_O365_CLIENT
                  }&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=normal&redirect_uri=${
                    process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL
                  }`
                )
              }
            >
              <div>
                <FontAwesomeIcon
                  icon={faOutlook}
                  size="3x"
                  color={colorExchange}
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginBottom: 10,
                  }}
                />
              </div>
               {t('accounts.microsoft_outlook')} {/* Localized */}
            </div>
            <div
              className="flex flex-row border p-4 gap-x-4 items-center text-xl cursor-pointer"
              onClick={(e) =>
                redirectToService(
                  `https://login.microsoftonline.us/common/oauth2/v2.0/authorize?prompt=login&client_id=${
                    process.env.REACT_APP_OAUTH_O365_CLIENT_GCC
                  }&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=gcc&redirect_uri=${
                    process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL
                  }`
                )
              }
            >
              <div>
                <FontAwesomeIcon
                  icon={faOutlook}
                  size="3x"
                  color={colorOutlook}
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginBottom: 10,
                  }}
                />
              </div>
              {t('accounts.microsoft_365_gcc')} {/* Localized */}
            </div>
          </div>
          <div>
            <div className="mt-4">
              <div className="text-lg mb-2">{t('accounts.other_calendar_types')}</div> {/* Localized */}
              <div className="pt-2 mb-2">{t('accounts.ics_sync_description')}</div> {/* Localized */}
              <a className="text-lg"
                target="_blank"
                href="https://help.calendarbridge.com/uncategorized/how-to-get-an-ics-url-for-you-calendar/"
              >
                {t('accounts.use_ics_shared_link')} {/* Localized */}
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
  function renderDeniedScopes() {
    return (
      <>
        <div className="cb-content-frame h-screen">
          <div className="cb-content-pane mobile_padding">
            <div className="rounded-sm border-2 border-neutral_1">
              <CBHeader
                icon={<Close></Close>}
                label={t('accounts.denied_scopes_header')} 
              ></CBHeader>
              <center>
                <img src={blurryGoog}></img>
              </center>
              {errorMessage && (
                <div className="text-lg m-4 text-burnt font-sarabun p-4 rounded-sm border-2 border-neutral_1">
                  {errorMessage}
                </div>
              )}
              <div className="flex justify-center mt-8 mb-8">
                <a
                  className="mt-2 mb-2 text-lg"
                  target="_blank"
                  href="https://help.calendarbridge.com/doc/getting-started/connecting-google-calendars/"
                >
                  {t('accounts.denied_scopes_help_link')} {/* Localized */}
                </a>
              </div>
              <div className="flex justify-center gap-x-4 mb-8">
                <CBButton
                  type="primary"
                  onClick={() => navigate('/dashboard/accounts/new')}
                >
                  {t('common.try_again_button')} {/* Localized */}
                </CBButton>
                <CBButton
                  type="secondary"
                  onClick={() => navigate('/dashboard/')}
                >
                  {t('accounts.return_to_dashboard')} {/* Localized */}
                </CBButton>
              </div>
            </div>
          </div>
        </div>
        {/* <Result
          status="warning"
          title="Darn! We had trouble linking your account."
          subTitle={errorMessage}
          extra={
            <CBButton onClick={() => navigate('/dashboard/accounts/new')}>
              Try Again
            </CBButton>
          }
        />
        <Footer></Footer> */}
      </>
    )
  }
  function renderError() {
    return (
      <>
        <SEO title={t('accounts.add_error_title')} /> {/* Localized */}
        <div className="cb-content-frame h-screen">
          <div className="cb-content-pane mobile_padding">
            <div className="rounded-sm border-2 border-neutral_1">
              <CBHeader
                icon={<Close></Close>}
                label={t('accounts.connect_error_header')} 
              ></CBHeader>
              {errorMessage && (
                <>
                  <div className="text-lg m-4 text-burnt font-sarabun p-4 rounded-sm border-2 border-neutral_1">
                    {errorMessage}
                  </div>
                  <div>
                    {' '}
                    <div className="m-8 text-lg">
                      {t('accounts.connect_error_help_intro')} {/* Localized */}
                      <div>
                        <a
                          target="_blank"
                          href="https://help.calendarbridge.com/user-docs/dashboard-error-messages/"
                        >
                          {t('accounts.connect_error_link1')} {/* Localized */}
                        </a>
                      </div>
                      <div>
                        <a
                          target="_blank"
                          href="https://help.calendarbridge.com/uncategorized/how-to-get-an-ics-url-for-you-calendar/"
                        >
                          {t('accounts.connect_error_link2')} {/* Localized */}
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="flex justify-center gap-x-4 mb-8">
                <CBButton
                  type="primary"
                  onClick={() => navigate('/dashboard/accounts/new')}
                >
                  {t('common.try_again_button')} {/* Localized */}
                </CBButton>
                <CBButton
                  type="secondary"
                  onClick={() => navigate('/dashboard/')}
                >
                  {t('accounts.return_to_dashboard')} {/* Localized */}
                </CBButton>
              </div>
            </div>
          </div>
        </div>
        {/* <Result
          status="warning"
          title="Darn! We had trouble linking your account."
          subTitle={errorMessage}
          extra={
            <CBButton onClick={() => navigate('/dashboard/accounts/new')}>
              Try Again
            </CBButton>
          }
        />
        <Footer></Footer> */}
      </>
    )
  }

  function renderDenied() {
    return (
      <>
        <SEO title={t('accounts.add_denied_title')} /> {/* Localized */}
        {/* Replaced style with Tailwind, removed Row/Col */}
        <div className="max-w-3xl mx-auto px-5 font-sarabun">
          <div className="text-center mt-12"> {/* Adjusted margin */}
              <h2 className="text-xl font-semibold">{t('accounts.connect_error_header')}</h2> {/* Localized */}
          </div>
          <div>
              <h4 className="leading-relaxed"> {/* Use Tailwind for line-height */}
                {t('accounts.denied_explanation')} {/* Localized */}
              </h4>
 
              <h3 style={{ marginTop: 20, marginBottom: 0 }}>
                {t('accounts.denied_corporate_policy_q')} {/* Localized */}
              </h3>
              <h4 style={{ lineHeight: '1.5em' }}>
                {t('accounts.denied_corporate_policy_a')} {/* Localized */}
                <a
                  href="https://help.calendarbridge.com/calendarbridge-security"
                  target="_blank"
                >
                  &nbsp;https://help.calendarbridge.com/calendarbridge-security
                </a>
              </h4>
 
              <h3 style={{ marginTop: 20, marginBottom: 0 }}>
                {t('accounts.denied_unsure_q')} {/* Localized */}
              </h3>
              <h4 style={{ lineHeight: '1.5em' }}>
                {t('accounts.denied_unsure_a')} {/* Localized */}
              </h4>

              <div
                className="flex mb-2
"
              >
                <Check className="flex-none mr-2" />
                <h4>
                  <b>
                    {t('accounts.denied_point1_bold')} {/* Localized */}
                  </b>{' '}
                  {t('accounts.denied_point1_normal')} {/* Localized */}
                </h4>
              </div>
              <div
                className="flex mb-2
"
              >
                <Check className="flex-none mr-2" />
                <h4>
                  <b>
                    {t('accounts.denied_point2_bold')} {/* Localized */}
                  </b>{' '}
                  {t('accounts.denied_point2_normal')}{' '} {/* Localized */}
                  <a
                    href="https://help.calendarbridge.com/calendarbridge-security"
                    target="_blank"
                  >
                    {t('accounts.denied_point2_link1')} {/* Localized */}
                  </a>{' '}
                  {t('common.and')}{' '} {/* Localized */}
                  <a
                    href="https://help.calendarbridge.com/terms-and-privacy/"
                    target="_blank"
                  >
                    {t('common.privacy_policy')} {/* Localized */}
                  </a>{' '}
                  {t('accounts.denied_point2_more_info')} {/* Localized */}
                </h4>
              </div>
              <div
                className="flex mb-2
"
              >
                <Check className="flex-none mr-2" />
                <h4>
                  <b>
                    {t('accounts.denied_point3_bold')} {/* Localized */}
                  </b>{' '}
                  {t('accounts.denied_point3_normal')}{' '} {/* Localized */}
                  <a href="https://help.calendarbridge.com/doc/account-management/disconnecting-a-google-account/">
                    {t('accounts.denied_point3_link')} {/* Localized */}
                  </a>
                </h4>
              </div>
          </div> {/* Close div replacing Col */}
          <div className="flex space-x-4 m-4 justify-center">
            <CBButton
              key="acct"
              onClick={() => navigate('/dashboard/accounts/new')}
              type="primary"
            >
              {t('accounts.denied_ready_button')} {/* Localized */}
            </CBButton>

            <CBButton
              key="acct"
              onClick={() => navigate('/dashboard/')}
              type="secondary"
            >
              {t('accounts.return_to_dashboard')} {/* Localized */}
            </CBButton>
          </div>
          {/* Removed Row/Col */}
          <div>
              <h4 className="leading-relaxed"> {/* Use Tailwind */}
                {t('accounts.denied_more_info_prompt')} {/* Localized */}
              </h4>
              {/* Replaced Collapse/Panel with Accordion */}
              <div className="space-y-2 mt-4"> {/* Add spacing */}
                <Accordion label={t('accounts.denied_msft_panel_header')}>
                  {/* Removed inline style from img */}
                  <img src={msftPermissions} className="mb-2 max-w-full h-auto" alt="Microsoft Permissions"></img> {/* Added alt */}
                  <p className="mb-2">{t('accounts.denied_msft_panel_p1')}</p> {/* Localized */}
                  <p className="mb-2">{t('accounts.denied_msft_panel_p2')}</p> {/* Localized */}
                  <p>{t('accounts.denied_msft_panel_p3')}</p> {/* Localized */}
                </Accordion>
                <Accordion label={t('accounts.denied_google_panel_header')}>
                   <img src={googlePermissions1} className="mb-2 max-w-full h-auto" alt="Google Permissions Step 1"></img>
                   <p className="mb-2">{t('accounts.denied_google_panel_p1')}</p> {/* Localized */}
                   <img src={googlePermissions2} className="mb-2 max-w-full h-auto" alt="Google Permissions Step 2"></img>
                   <p className="mb-2">{t('accounts.denied_google_panel_p2')}</p> {/* Localized */}
                   <img src={googlePermissions3} className="mb-2 max-w-full h-auto" alt="Google Permissions Step 3"></img>
                   <p>{t('accounts.denied_google_panel_p3')}</p> {/* Localized */}
                </Accordion>
              </div>
          </div> {/* Close div replacing Col */}
        </div>
      </>
    )
  }

  function renderComplete() {
    return (
      <>
        <SEO title={t('accounts.add_success_title')} /> {/* Localized */}
        <div className="cb-content-frame p-4">
          <div className="cb-content-pane mobile_padding">
            <CBHeader icon={<Check></Check>} label={t('accounts.account_added')}></CBHeader> {/* Localized */}
            <div className="grid grid-cols-1 gap-2 mb-2">
              <div
                className="main-grid-item hover:bg-neutral_1"
                onClick={(e) => navigate('/dashboard/accounts/new')}
              >
                <div class="t3  flex flex-row gap-4">
                  {' '}
                  <Connections></Connections>{t('accounts.add_another_account')} {/* Localized */}
                </div>
              </div>

              <div
                onClick={(e) => navigate('/dashboard/syncs/new')}
                className="main-grid-item hover:bg-neutral_1"
              >
                <div class="t3  flex flex-row gap-4">
                  {' '}
                  <NewSync></NewSync> {t('accounts.start_syncing_calendars')} {/* Localized */}
                </div>
              </div>

              <div
                className="main-grid-item hover:bg-neutral_1"
                onClick={(e) => navigate('/dashboard/schedules/new')}
              >
                <div class="t3 flex flex-row gap-4">
                  {' '}
                  <NewBooking></NewBooking> {t('accounts.create_scheduling_link')} {/* Localized */}
                </div>
              </div>
            </div>
            <CBListItem
              icon={<Arrow></Arrow>}
              borderLight={true}
              onClick={(e) => navigate('/dashboard/')}
            >
              {t('accounts.return_to_dashboard')} {/* Localized */}
            </CBListItem>
          </div>
        </div>
        {/* <Result
          status="success"
          title="Account Added!"
          subTitle="You can now sync calendars or add another account."
          extra={[
            <Button key="sync" onClick={() => navigate('/dashboard/syncs/new')}>
              Start Syncing Calendars
            </Button>,
            <Button
              key="acct"
              onClick={() => navigate('/dashboard/accounts/new')}
            >
              Add Another Account
            </Button>,
            <Button
              key="acct"
              onClick={() => navigate('/dashboard/schedules/new')}
            >
              Create A Scheduling Link
            </Button>,
            <Button key="acct" onClick={() => navigate('/dashboard/')}>
              Return To Dashboard
            </Button>,
          ]}
        />
        <Footer></Footer> */}
      </>
    )
  }

  if (showList) {
    return renderSelector()
  } else if (callbackStatus === 'loading') {
    return (
      // Replaced Spin with CBSpin
      <div className="text-center pt-24"> {/* Use Tailwind */}
        <CBSpin
          spinning={true}
          size="large" // Corresponds roughly to fontSize: '100px'
          
        />
      </div>
    )
  } else if (callbackStatus === 'success') {
    return renderComplete()
  } else if (callbackStatus === 'denied') {
    return renderDenied()
  } else if (callbackStatus === 'denied_scopes') {
    return renderDeniedScopes()
  } else {
    return renderError()
  }
}

const styles = {
  main: {
    maxWidth: 800,
    margin: '0 auto',
    padding: '0 20px',
  },
}

export default AccountCreatePage
